/**
 * @fileOverview detail.preview.component.ts - Live data from GPP/MYSA
 * @author Ivelin Ivanov
 */
var tempthat = {};
var DetailPreviewController = (function () {
    function DetailPreviewController($rootScope, $timeout, $q, socket, $stateParams, topic, settings, $scope, env) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.topic = topic;
        this.settings = settings;
        this.$scope = $scope;
        this.env = env;
        this.comp = 'gpp_live';
        this.id = $stateParams.id;
        this.socket.forward('preview.preview', this.$rootScope);
        this.$scope.$on('socket:preview.preview', function (event, data) {
            _this.loadData(event, data);
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getTopicErrorsPreview',
                    id: _this.id,
                    script: '/detail/general/general',
                    user: _this.env.user
                }
            });
        });
        this.socket.forward('preview.preview_errors', this.$rootScope);
        this.$scope.$on('socket:preview.preview_errors', function (event, data) {
            _this.topic.topic.errors = data.errors;
        });
        this.topic.loaded.topic = false;
        this.$rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            tempthat['viewLoaded'] = true;
        });
    }
    DetailPreviewController.prototype.$onDestroy = function () {
        //Wipe the topic from the browser.  Why? Because if it is assigned and that is the next claim to be entered,
        //the old preview topic will reappear rather than being reloaded
        //this.topic.clearTopic(this.id); 
        this.topic.reloadCheck.id = '';
    };
    DetailPreviewController.prototype.$onInit = function () {
        if (tempthat['viewLoaded']) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getGppData',
                    script: '/detail/general/general',
                    data: {
                        opp: this.id
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    DetailPreviewController.prototype.loadData = function (ev, results) {
        this.topic.clearTopic(this.id);
        this.topic.updateTopicWithoutCalc(results);
        this.topic.loaded.topic = true;
        this.tempData = results;
    };
    DetailPreviewController.$inject = ['$rootScope', '$timeout', '$q', 'socket', '$stateParams', 'topic', 'settings', '$scope', 'env'];
    return DetailPreviewController;
}());
var DetailPreviewComponent = (function () {
    function DetailPreviewComponent() {
        //templateUrl = 'detail-preview.html';
        this.templateUrl = 'detail-preview.html';
        this.controllerAs = 'vm';
        this.controller = DetailPreviewController;
    }
    return DetailPreviewComponent;
}());
angular
    .module('application')
    .component('previewSection', new DetailPreviewComponent());

//# sourceMappingURL=detail.preview.component.js.map
